interface UserProfileCardProps {
  name: string;
  email: string;
  initials: string;
  /** Profile photo URL from account (e.g. GET /auth/me/profile). */
  imageUrl?: string;
}

export function UserProfileCard({ name, email, initials, imageUrl }: UserProfileCardProps) {
  const showPhoto = Boolean(imageUrl?.trim());

  return (
    <div className="bg-card m-4 p-6 rounded-xl shadow-sm border border-border">
      <div className="flex items-start gap-4">
        <div className="w-16 h-16 shrink-0 bg-primary rounded-full flex items-center justify-center text-primary-foreground text-2xl overflow-hidden">
          {showPhoto ? (
            <img
              src={imageUrl!.trim()}
              alt=""
              className="w-full h-full object-cover"
              referrerPolicy="no-referrer"
            />
          ) : (
            initials
          )}
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-medium break-words">{name}</h3>
          <p
            className="text-sm text-muted-foreground break-all mt-0.5"
            title={email.length > 0 ? email : undefined}
          >
            {email}
          </p>
        </div>
      </div>
    </div>
  );
}
